import { SignedOut } from "@clerk/nextjs";
// import dynamic from "next/dynamic";
import { useContext, useState } from "react";
// const BsRocketTakeoff = dynamic(() =>
//   import("react-icons/bs").then((mod) => mod.BsRocketTakeoff)
// );
import CartSummary from "components/ecommerce/cart/CartSummary/CartSummary";
import { BsRocketTakeoff } from "react-icons/bs";
// const ExperienceCartItem = dynamic(
//   () => import("components/ecommerce/cart/CartItem/ExperienceCartItem")
// );
import ExperienceCartItem from "components/ecommerce/cart/CartItem/ExperienceCartItem";
// const Checkout = dynamic(
//   () => import("components/ecommerce/checkout/Checkout")
// );
import CharityLogoBars from "@/components/content/CharityLogos/CharityLogoBars";
import Checkout from "components/ecommerce/checkout/Checkout";
// const SlideOver = dynamic(() => import("@/components/ui/SlideOver/SlideOver"));
import SignUpSignInModal from "@/components/auth/clerk/SignUpSignInModal";
import SlideOver from "@/components/ui/SlideOver/SlideOver";

import { UserContext } from "contexts/user";
// import { fetchLayoutData, fetchLayoutDataServer } from "lib/api/strapi-layout";
import { useCart } from "lib/hooks/useCart";
import styles from "./Cart.module.scss";

export default function Cart({}) {
  const [isCheckoutSlideoverActive, setIsCheckoutSlideOverActive] =
    useState(false);
  const { userData } = useContext(UserContext);
  const { cart } = userData;
  const { experiences: cartExperiences, items } = cart;

  const { isCartUpdating } = useCart();

  const openCheckoutSlideOver = () => {
    setIsCheckoutSlideOverActive(true);
  };

  const closeCheckoutSlideOver = () => {
    setIsCheckoutSlideOverActive(false);
  };

  const handleFormClose = () => {
    closeCheckoutSlideOver();
  };

  const experienceItems =
    !!cartExperiences?.length > 0 && Array.isArray(items) && !!items?.length > 0
      ? items.map((item) => {
          const { id } = item;

          if (!cartExperiences[0] | !id) {
            return null;
          }

          const experience = cartExperiences.find((experience) => {
            return (
              experience?.data?.attributes?.metadata?.experience_code?.toString() ===
              id.toString()
            );
          });

          return { ...item, experience };
        })
      : [];

  const experienceCartItemElements = experienceItems.map((item) => {
    return (
      <ExperienceCartItem
        key={`${item.cartId}-${item.id}`}
        experience={item.experience}
        item={item}
      />
    );
  });

  return (
    <main className={`variable-container ${styles.cartContainer}`}>
      <SignedOut>
        <div className={`${styles.signUpPrompt}`}>
          <span className={`${styles.icon}`}>
            <BsRocketTakeoff color="var(--light-text)" size="100%" />
          </span>
          <div className={`${styles.signUpPromptText}`}>
            <SignUpSignInModal
              buttonMode="button"
              buttonClassName={`${styles.clerkButton}`}
              redirectUrl="/cart"
              buttonText="Sign in or create an account"
            />{" "}
            to check out and track your order more easily
          </div>
        </div>
      </SignedOut>
      <section
        className={`${styles.cartContent} ${
          isCheckoutSlideoverActive ? styles.active : ""
        }`}
      >
        {experienceCartItemElements && experienceCartItemElements}
        {!experienceCartItemElements?.length && !isCartUpdating && (
          <p className={`${styles.emptyCartMessage}`}>Your cart is empty.</p>
        )}

        <SlideOver
          position="mobilePage"
          isActive={isCheckoutSlideoverActive}
          handleCloseButtonClick={closeCheckoutSlideOver}
        >
          <div style={{ height: "10px" }}></div>
          <Checkout onFormClose={handleFormClose} />
          <div style={{ height: "100px" }}></div>
        </SlideOver>
      </section>
      <section className={`${styles.cartSummary}`}>
        <CartSummary
          onCheckoutClick={
            isCheckoutSlideoverActive
              ? closeCheckoutSlideOver
              : openCheckoutSlideOver
          }
          isCheckoutActive={isCheckoutSlideoverActive}
        />
      </section>
      <div className={`${styles.charityBanners}`}>
        <CharityLogoBars />
      </div>
    </main>
  );
}

// export async function getStaticProps({}) {
//   // const layoutData = await fetchLayoutData();
//   const layoutData = await fetchLayoutDataServer();

//   return {
//     props: {
//       layoutData,
//     },
//   };
// }
